import React from 'react';

const IconZalo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" strokeWidth="2" viewBox="0 0 24 24">
    {' '}
    <path
      fill="currentColor"
      d="M17.741,12c-0.69,0-1.252-0.562-1.252-1.252s0.562-1.252,1.252-1.252s1.252,0.562,1.252,1.252 S18.431,12,17.741,12z M17.741,9.996c-0.414,0-0.751,0.337-0.751,0.751s0.337,0.751,0.751,0.751s0.751-0.337,0.751-0.751 S18.155,9.996,17.741,9.996z"></path>
    <path
      fill="currentColor"
      d="M15.988,12h-0.334c-0.092,0-0.167-0.075-0.167-0.167V8.995h0.501V12z"></path>
    <path
      fill="currentColor"
      d="M14.485,9.579v0.173c-0.21-0.159-0.468-0.257-0.751-0.257c-0.69,0-1.252,0.562-1.252,1.252 S13.044,12,13.734,12c0.283,0,0.541-0.098,0.751-0.257v0.09c0,0.092,0.075,0.167,0.167,0.167h0.334V9.579H14.485z M13.734,11.499 c-0.414,0-0.751-0.337-0.751-0.751s0.337-0.751,0.751-0.751s0.751,0.337,0.751,0.751S14.148,11.499,13.734,11.499z"></path>
    <path
      fill="currentColor"
      d="M12.565,8.995H9.894v0.501h1.777l-1.86,2.171h0.009c-0.054,0.07-0.092,0.155-0.092,0.25V12h2.504 c0.092,0,0.167-0.075,0.167-0.167v-0.334h-1.777l1.86-2.171h-0.009c0.054-0.07,0.092-0.155,0.092-0.25V8.995z"></path>
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17,20H7c-1.657,0-3-1.343-3-3V7 c0-1.657,1.343-3,3-3h10c1.657,0,3,1.343,3,3v10C20,18.657,18.657,20,17,20z"></path>
    <path
      fill="currentColor"
      d="M15,18c-1.507,0-2.995-0.385-4.322-1.114L6.994,17l0.423-3.161C6.489,12.39,6,10.725,6,9 c0-2.04,0.701-4.038,1.975-5.626l1.561,1.252C8.531,5.878,8,7.391,8,9c0,1.444,0.441,2.835,1.276,4.021l0.225,0.32l-0.212,1.586 l1.899-0.059l0.25,0.148C12.522,15.66,13.753,16,15,16c1.609,0,3.122-0.531,4.375-1.535l1.251,1.561C19.037,17.299,17.039,18,15,18 z"></path>{' '}
  </svg>
);

export default IconZalo;
